import { format } from "date-fns";
import { DateRange } from "react-day-picker";
import PresetStatsService from "../services/presetStatsService";
import {
  GetPresetStatsParams,
} from "../model/presetStats.types";
import { useCustomQuery } from "@/shared/hooks/useCustomQuery";
import { StatsType, SortOption } from "../model/analytics.types";

interface UsePresetStatsParams {
  type: StatsType;
  dateRange: DateRange | undefined;
  search?: string;
  page?: number;
  limit?: number;
  sortBy?: SortOption;
  sortOrder?: 'asc' | 'desc';
}

export function usePresetStats({
  type,
  dateRange,
  search = "",
  page = 1,
  limit = 10,
  sortBy = "preset",
  sortOrder = "desc",
}: UsePresetStatsParams) {
  const formatDate = (date: Date | undefined) =>
    date ? format(date, "yyyy-MM-dd") : "";

  const param: GetPresetStatsParams = {
    startDate: formatDate(dateRange?.from) || "",
    endDate: formatDate(dateRange?.to) || "",
    groupBy: type,
    search,
    page,
    limit,
    sortBy,
    sortOrder,
  };


  const queryResult = useCustomQuery({
    serviceInstance: PresetStatsService.Instance,
    selectAction: (svc) => svc.getPresetStats,
    parameter: param,
    options: {
      enabled: !!dateRange?.from && !!dateRange?.to && !!type,
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
    },
  });


  return queryResult;
}
